import { ContactCardDto } from '../types/swaggerTypes'

export const getUserPhone = (
  contactCard?: ContactCardDto,
  countryCode?: string
) => {
  if (!contactCard || !contactCard.customerPhones) {
    return ''
  }
  const mobilePhone = contactCard.customerPhones.find(
    (x) => x.phoneType === 'MOBILE'
  )

  if (mobilePhone) {
    const code = mobilePhone.countryCode || countryCode || ''
    const prefix = code ? `+${code} ` : ''
    return `${prefix}${mobilePhone.areaCode} ${mobilePhone.phoneNumber}`
  }

  const genericNumber = contactCard.customerPhones.find(
    (x) => x.phoneType === 'GEN'
  )
  if (genericNumber) {
    const code = genericNumber.countryCode || countryCode || ''
    const prefix = code ? `+${code} ` : ''
    return `${prefix}${genericNumber.areaCode} ${genericNumber.phoneNumber}`
  }

  return ''
}
